import { FC } from 'react';

const Space: FC<{ size?: 'small' | 'medium' | 'large' }> = ({ size = 'medium' }) => (
  <div className={{
    small:  'h-[.5em]',
    medium: 'h-[1em]',
    large:  'h-[2em]',   
  }[size]} />
);

export default Space;
